import type { InjectionKey } from "vue";
import type { AppConfig } from "../app_config_provider";

const API_PATH = "/infos";

export interface SenderDto {
  id: number;
  pos: number;
  type: string;
  info_category_ids: string;
  imate: string;
  title: string;
  tags: string;
  image_url: string;
}

export class InfoApi {
  private readonly config: Pick<AppConfig, "api_url" | "api_token">;

  constructor(config: Pick<AppConfig, "api_url" | "api_token">) {
    this.config = config;
  }

  async getSender(pkg: string): Promise<SenderDto[]> {
    const response = await fetch(
      `${this.config.api_url}${API_PATH}/sender/${encodeURIComponent(pkg)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-API-TOKEN": this.config.api_token,
        },
      },
    );

    if (!response.ok) {
      console.log(`getSender failed: ${response.status} ${response.statusText}`);
      throw new Error("General_Api_Failed");
    }

    return response.json() as Promise<SenderDto[]>;
  }
}

export const infoApiKey: InjectionKey<InfoApi> = Symbol("info-api");
